var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { QuiTextInput } from "../../QuiTextInput/QuiTextInput.js";
import { QuiField } from "../QuiField.js";
import { useQuiField } from "../useQuiField.js";
// TValue represents the underlying data-type. If different from string, you can provide format and parse props to convert to and from the input element
/** Controlled text field component that manages field state within a form */
export const QuiTextField = forwardRef(function QuiTextField(_a, ref) {
    var { name, disabled, label, helperText, subHelperText, size, iconLeft, iconRight, placeholder, maxLength, autoComplete, validate, config, onBlur } = _a, otherProps = __rest(_a, ["name", "disabled", "label", "helperText", "subHelperText", "size", "iconLeft", "iconRight", "placeholder", "maxLength", "autoComplete", "validate", "config", "onBlur"]);
    const { inputProps, fieldProps } = useQuiField(name, Object.assign(Object.assign({}, config), { validate }));
    return (React.createElement(QuiField, Object.assign({ label: label, helperText: helperText, subHelperText: subHelperText, disabled: disabled }, fieldProps, otherProps),
        React.createElement(QuiTextInput, Object.assign({ placeholder: placeholder, size: size, iconLeft: iconLeft, iconRight: iconRight, maxLength: maxLength, disabled: disabled }, inputProps, { onBlur: () => {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur();
                inputProps.onBlur();
            }, autoComplete: autoComplete, "data-lpignore": autoComplete === "off", ref: ref }))));
});
